const configData = {
  serverUrl: 'https://api.fisiologiadotreinamento.com'
}
module.exports = configData;
